var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0146 26.2936L31.8784 1.15734C30.336 -0.385781 27.8351 -0.385781 26.2927 1.15734L1.1565 26.2936C-0.3855 27.8356 -0.3855 30.3368 1.1565 31.8792L26.2927 57.0155C27.8351 58.5578 30.336 58.5578 31.8784 57.0155L57.0146 31.8792C58.557 30.3368 58.557 27.8356 57.0146 26.2936ZM27.1106 52.2477L4.64775 29.7845C4.26187 29.3986 4.26187 28.7738 4.64775 28.3883L27.1106 5.92509V52.2477ZM31.0609 52.2477V5.92509L41.823 16.688L32.2178 26.2936C30.6746 27.8356 30.6746 30.3368 32.2178 31.8792L41.823 41.4848L31.0609 52.2477ZM53.5234 29.7845L44.616 38.6922L35.7086 29.7845C35.3228 29.3986 35.3228 28.7738 35.7086 28.3883L44.616 19.4806L53.5234 28.3883C53.9096 28.7738 53.9096 29.3986 53.5234 29.7845Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.60ef2d72657ce9b416826307c468c1a1.svg";
export { ForwardRef as ReactComponent };